import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './TargetOverlay.module.scss'

const TargetOverlay = ({
  targetQuery,
  element: Element = 'div',
  className,
  children,
}) => {
  const [targetPos, setParentPos] = useState(null)

  const setPosition = useCallback(() => {
    const target = window.document.querySelector(targetQuery)
    const pos = target ? target.getBoundingClientRect() : null

    setParentPos(pos)
  }, [targetQuery])

  useEffect(() => {
    setPosition()
    window.addEventListener('resize', setPosition)

    return () => {
      window.removeEventListener('resize', setPosition)
      setPosition()
    }
  }, [setPosition])

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(setPosition)
    })

    const body = document.querySelector('body')
    const config = {
      childList: true,
      subtree: true,
    }

    observer.observe(body, config)

    return () => {
      observer.disconnect()
    }
  }, [setPosition])

  return (
    <Element
      className={classnames(styles.root, className)}
      style={{
        top: targetPos?.top ?? 0,
        left: targetPos?.left ?? 0,
        width: targetPos?.width ?? 0,
        height: 0, // TODO: We only want to draw height OR width, otherwise overlays Target, only width for now...
      }}
    >
      {children}
    </Element>
  )
}

TargetOverlay.propTypes = {
  targetQuery: PropTypes.string,
  element: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  children: PropTypes.any,
}

export default TargetOverlay
